"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ExcludeCharge_1 = __importDefault(require("atomicComponents/molecules/Icon/ModalIcons/ExcludeCharge"));
var ModalWithActions_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalWithActions"));
var ExcludeIncludeModal = function (_a) {
    var actionType = _a.actionType, _b = _a.buttonTextPostFix, buttonTextPostFix = _b === void 0 ? '' : _b, props = __rest(_a, ["actionType", "buttonTextPostFix"]);
    return ((0, jsx_runtime_1.jsx)(ModalWithActions_1.default, __assign({}, props, { status: actionType === 'exclude' ? 'error' : 'success', modalIcon: actionType === 'exclude'
            ? (0, jsx_runtime_1.jsx)(ExcludeCharge_1.default, { size: "xl" })
            : (0, jsx_runtime_1.jsx)("img", { src: "/RevertBlend.svg", alt: "Include icon", height: 64, width: 64 }), okText: "".concat(actionType === 'exclude' ? 'Exclude' : 'Revert exclusion').concat(buttonTextPostFix) })));
};
exports.default = ExcludeIncludeModal;
